import { useMutation } from '@tanstack/react-query'
import { queryClient } from 'src'
import { invalidateVesselCertificateQueries } from '~hooks/queries/vessels/invalidate-vessel-certificate-queries'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'

interface DeleteDocumentPayload {
  vesselId: string
  documentName: string
}

interface DeleteDocumentResponse {
  files?: unknown[]
  statusCode?: number
}

export function useDeleteDocument() {
  const fetchRequest = useFetch()

  return useMutation<DeleteDocumentResponse, Error, DeleteDocumentPayload>({
    mutationFn: ({ vesselId, documentName }) =>
      fetchRequest(
        `${apiBase()}/vessels/${vesselId}/documents?documentName=${encodeURIComponent(documentName)}`,
        undefined,
        undefined,
        'DELETE',
      ) as Promise<DeleteDocumentResponse>,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [`/vessels/${variables.vesselId}/documents`],
      })
      invalidateVesselCertificateQueries(variables.vesselId)
    },
  })
}
